import { convertNumber } from "utils";
import { BillStatusResponse } from "../types";

export interface FotherSectionProps {
  data: BillStatusResponse[]
}

export const FotherSection = ({ data }: FotherSectionProps) => {
  const totalSubtotal = data.reduce((total, item) => total + parseFloat(item?.total ?? 0), 0);
  const totalPayment = data.reduce((total, item) => total + parseFloat(item?.payment ?? 0), 0);
  const totalBalance = data.reduce((total, item) => total + Number(item.total_tax_paid) + Number(item.total) + Number(item.freight) - parseFloat((item?.payment ?? 0)), 0);

  return (
    <div>
      <div>
        <div className="label-text font-bold flex justify-end text-right">
          <div>
            <div>SUMMARY SUBTOTAL</div>
            <div>SUMMARY PAYMENT</div>
            <div>SUMMARY BALANCE</div>
          </div>
          <div className="mx-2">
            <div>:</div>
            <div>:</div>
            <div>:</div>
          </div>
          <div>
            <div>{totalSubtotal ? convertNumber(totalSubtotal)?.intoCurrency : "0"}</div>
            <div>{totalPayment ? convertNumber(totalPayment)?.intoCurrency : "0"}</div>
            <div>{totalBalance ? convertNumber(totalBalance)?.intoCurrency : "0"}</div>
          </div>
        </div>
      </div>
    </div>
  )
}